module.exports = __webpack_public_path__ + "static/img/logo-member.006cadd3.jpg";